import { render, staticRenderFns } from "./CustomerTypeList.vue?vue&type=template&id=4bb439a7&scoped=true"
import script from "./CustomerTypeList.vue?vue&type=script&lang=js"
export * from "./CustomerTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb439a7",
  null
  
)

export default component.exports